<template>
  <q-page style="min-height: auto !important">
    <div class="row q-pa-lg q-mb-lg">
      <div class="text-h5 pc-semibold text-grey-9">
        Welcome,
        <span class="text-indigo-6">{{ currentUser.name }}</span>
      </div>
    </div>
    <div class="row q-px-lg q-mb-md" v-if="!showNewPasswordContainer">
      <q-space />
      <div>
        <q-btn
          :label="showSearchContainer ? 'Cancel' : 'Search'"
          :icon="showSearchContainer ? 'close' : 'search'"
          flat
          rounded
          :color="showSearchContainer ? 'red-6' : 'indigo-6'"
          no-caps
          @click="openSearchContainer()"
        />
        <q-btn
          label="New password"
          icon="enhanced_encryption"
          flat
          rounded
          color="amber-6"
          no-caps
          @click="openNewPassContainer()"
        />
      </div>
    </div>
    <div class="row q-px-lg q-mb-md" v-else>
      <q-space />
      <q-btn
        label="Cancel"
        icon="close"
        flat
        rounded
        color="red-6"
        no-caps
        @click="cancelNewPass()"
      />
      <q-btn
        label="Save"
        icon="check"
        flat
        rounded
        color="green-6"
        no-caps
        @click="createPassword()"
      />
    </div>
    <q-slide-transition>
      <div v-show="showNewPasswordContainer" class="bg-grey-1">
        <div class="top-shadow">
          <div class="bottom-shadow">
            <div class="q-px-lg q-pt-lg q-pb-md">
              <q-select
                label="Service (optional)"
                rounded
                standout="bg-indigo-6 text-white"
                class="q-mb-md"
                :options="services"
                v-model="newPasswordForm.service"
                emit-value
                map-options
              >
                <template v-slot:option="scope">
                  <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                    <q-item-section avatar>
                      <q-icon :name="scope.opt.value" />
                    </q-item-section>
                    <q-item-section>
                      <q-item-label>
                        {{ scope.opt.label }}
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
              <q-input
                label="Name (optional)"
                rounded
                standout="bg-indigo-6 text-white"
                class="q-mb-md"
                v-model="newPasswordForm.name"
              />
              <q-input
                label="User"
                rounded
                standout="bg-indigo-6 text-white"
                class="q-mb-md"
                v-model="newPasswordForm.user"
              />
              <q-input
                label="Password"
                rounded
                standout="bg-indigo-6 text-white"
                class="q-mb-xs copyPass"
                v-model="newPasswordForm.password"
              >
                <template v-slot:after>
                  <q-btn
                    round
                    dense
                    flat
                    icon="content_copy"
                    color="indigo-6"
                    @click="copyToClipboard(newPasswordForm.password)"
                  />
                </template>
              </q-input>
              <q-btn
                label="Auto-generate"
                flat
                color="amber-6"
                size="sm"
                rounded
                no-caps
                @click="generateStrongPass()"
              />
            </div>
          </div>
        </div>
      </div>
    </q-slide-transition>
    <q-slide-transition>
      <div v-show="showSearchContainer" class="bg-grey-1">
        <div class="top-shadow">
          <div class="bottom-shadow">
            <div class="q-px-lg q-pt-lg q-pb-md">
              <q-input
                label="Search"
                rounded
                standout="bg-indigo-6 text-white"
                ref="search"
                v-model="searchInput"
              >
                <template v-if="searchInput" v-slot:append>
                  <q-icon
                    name="cancel"
                    @click.stop="searchInput = ''"
                    class="cursor-pointer"
                  />
                </template>
              </q-input>
            </div>
          </div>
        </div>
      </div>
    </q-slide-transition>

    <div class="q-pa-lg">
      <div
        class="row bg-grey-3 pass-row q-mb-md"
        v-for="(pass, i) in returnFilteredPasswords"
        :key="i"
      >
        <div class="col-xs-2 q-pa-md  flex flex-center">
          <q-icon :name="pass.service" v-if="pass.service" />
        </div>
        <div
          class="col-xs-6 q-pa-md flex flex-center"
          @click="$router.push(`/pass/${pass.id}`)"
        >
          <div class="text-body2 text-left full-width" v-if="!pass.visibility">
            {{ pass.user }}
          </div>
          <div class="text-body2 text-left full-width" v-else>
            {{ pass.password }}
          </div>
          <div class="text-caption text-left full-width text-grey-6">
            {{ pass.name }}
          </div>
        </div>
        <div class="col-xs-4 q-pa-md flex flex-center">
          <q-btn
            :icon="pass.visibility ? 'visibility_off' : 'visibility'"
            flat
            round
            size="sm"
            color="grey-9"
            @click="pass.visibility = !pass.visibility"
          />
          <q-btn
            icon="content_copy"
            flat
            round
            size="sm"
            color="grey-9"
            @click="copyToClipboard(pass.password)"
          />
        </div>
      </div>
    </div>
    <div
      class="text-h5 text-center pc-bold text-grey-4 q-mt-xl"
      v-if="userPasswords.length <= 0"
    >
      No passwords yet.
    </div>
  </q-page>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  framework: {
    plugins: ["Notify"],
  },
  data() {
    return {
      showNewPasswordContainer: false,
      showSearchContainer: false,
      searchInput: "",
      newPasswordForm: {
        service: "",
        name: "",
        user: "",
        password: "",
        visibility: false,
      },
      services: [
        { label: "Other", value: "fas fa-star" },
        { label: "Airbnb", value: "fab fa-airbnb" },
        { label: "Amazon", value: "fab fa-amazon" },
        { label: "Apple", value: "fab fa-apple" },
        { label: "Battle.net", value: "fab fa-battle-net" },
        { label: "Discord", value: "fab fa-discord" },
        { label: "Dropbox", value: "fab fa-dropbox" },
        { label: "Ebay", value: "fab fa-ebay" },
        { label: "Facebook", value: "fab fa-facebook-square" },
        { label: "Github", value: "fab fa-github" },
        { label: "Google", value: "fab fa-google" },
        { label: "Instagram", value: "fab fa-instagram" },
        { label: "Microsoft", value: "fab fa-microsoft" },
        { label: "Paypal", value: "fab fa-paypal" },
        { label: "Pinterest", value: "fab fa-pinterest" },
        { label: "PlayStation", value: "fab fa-playstation" },
        { label: "Skype", value: "fab fa-skype" },
        { label: "Snapchat", value: "fab fa-snapchat-ghost" },
        { label: "Soundcloud", value: "fab fa-soundcloud" },
        { label: "Spotify", value: "fab fa-spotify" },
        { label: "Steam", value: "fab fa-steam" },
        { label: "TikTok", value: "fab fa-tiktok" },
        { label: "Trello", value: "fab fa-trello" },
        { label: "Twitch", value: "fab fa-twitch" },
        { label: "Twitter", value: "fab fa-twitter" },
        { label: "Uber", value: "fab fa-uber" },
        { label: "Xbox", value: "fab fa-xbox" },
        { label: "Youtube", value: "fab fa-youtube" },
      ],
    };
  },
  methods: {
    ...mapActions("appStore", ["createUserPassword"]),

    openNewPassContainer() {
      this.showNewPasswordContainer = true;
      this.showSearchContainer = false;
    },
    openSearchContainer() {
      this.showSearchContainer = !this.showSearchContainer;
      if (this.showSearchContainer) {
        setTimeout(() => {
          this.$refs.search.focus();
        }, 300);
      } else {
        this.searchInput = "";
      }
    },
    cancelNewPass() {
      this.newPasswordForm.service = "";
      this.newPasswordForm.user = "";
      this.newPasswordForm.password = "";
      this.showNewPasswordContainer = false;
    },
    generateStrongPass() {
      var specials = "!@#$%&*()";
      var lowercase = "abcdefghijklmnopqrstuvwxyz";
      var uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      var numbers = "0123456789";
      var all = specials + lowercase + uppercase + numbers;
      String.prototype.pick = function(min, max) {
        var n,
          chars = "";
        if (typeof max === "undefined") {
          n = min;
        } else {
          n = min + Math.floor(Math.random() * (max - min));
        }

        for (var i = 0; i < n; i++) {
          chars += this.charAt(Math.floor(Math.random() * this.length));
        }

        return chars;
      };
      String.prototype.shuffle = function() {
        var array = this.split("");
        var tmp,
          current,
          top = array.length;

        if (top)
          while (--top) {
            current = Math.floor(Math.random() * (top + 1));
            tmp = array[current];
            array[current] = array[top];
            array[top] = tmp;
          }

        return array.join("");
      };
      var password = (
        specials.pick(1) +
        lowercase.pick(1) +
        uppercase.pick(1) +
        all.pick(10, 10)
      ).shuffle();
      this.newPasswordForm.password = password;
    },
    createPassword() {
      if (!this.newPasswordForm.user || !this.newPasswordForm.password) {
        this.$q.notify({
          message: "User and password fields are required",
          color: "red-6",
          icon: "check",
          badgeColor: "amber-6",
          progress: true,
          classes: "pc-font pc-semibold higher-toast",
          timeout: 2000,
        });
      } else {
        this.createUserPassword(this.newPasswordForm);
      }
    },
    copyToClipboard(text) {
      this.$clipboard(text);
      this.$q.notify({
        message: "Password copied!",
        color: "indigo-6",
        icon: "check",
        badgeColor: "amber-6",
        progress: true,
        classes: "pc-font pc-semibold higher-toast",
        timeout: 500,
      });
    },
  },
  computed: {
    ...mapState("appStore", ["currentUser", "userPasswords"]),

    returnFilteredPasswords() {
      let passwords = [];
      this.userPasswords.forEach((pass) => {
        if (
          pass.user.toLowerCase().includes(this.searchInput.toLowerCase()) ||
          pass.service.toLowerCase().includes(this.searchInput.toLowerCase()) ||
          (pass.name &&
            pass.name.toLowerCase().includes(this.searchInput.toLowerCase()))
        ) {
          passwords.push(pass);
        }
      });
      return passwords;
    },
  },
};
</script>

<style>
.top-shadow {
  box-shadow: inset 0 7px 9px -7px rgba(0, 0, 0, 0.1);
}
.bottom-shadow {
  box-shadow: inset 0 -7px 9px -7px rgba(0, 0, 0, 0.1);
}
.pass-row {
  border-radius: 25px;
}
.higher-toast {
  margin-bottom: 25px !important;
}
</style>
